export default __webpack_public_path__ + "static/media/Linux-Pinguino.2ea04879.svg";